// Detects whether the current URL is an OAuth redirect back from Cognito.
// With responseType "token" (implicit flow) the tokens arrive in the hash
// (#access_token=...&id_token=...); with "code" flow they arrive in the query
// string (?code=...). Errors arrive as error/error_description in either.
// When this returns true, Amplify is (or soon will be) processing the
// response and will announce the outcome via a Hub "auth" event — the app
// must wait on that instead of treating the user as signed out.
export const hasOAuthResponseInUrl = (): boolean => {
  const { search, hash } = window.location;

  const searchParams = new URLSearchParams(search);
  if (searchParams.has("code") || searchParams.has("error")) {
    return true;
  }

  const hashParams = new URLSearchParams(hash.replace(/^#/, ""));
  return (
    hashParams.has("access_token") ||
    hashParams.has("id_token") ||
    hashParams.has("error")
  );
};
